import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { Component, input } from '@angular/core';

export type CandidateFieldRow = {
  value: string;
  isValid?: boolean;
};

@Component({
  selector: 'rt-candidate-field-row-simple',
  imports: [NgTemplateOutlet],
  templateUrl: './candidate-field-row-simple.component.html',
  styleUrl: './candidate-field-row-simple.component.less',
})
export class CandidateFieldRowSimpleComponent {
  public name = input.required<string>();
  public fieldDisplayTpl = input<TemplateRef<any>>();
}
